(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["race-strategy-calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SVG_NS = 'http://www.w3.org/2000/svg';

    var platformPresets = {
      iracing: { fuelUnit: 'L', tankCapacity: 120, pitLoss: 36, refuelRate: 2.4, reserveLaps: 1, finishBuffer: 1 },
      acc: { fuelUnit: 'L', tankCapacity: 120, pitLoss: 30, refuelRate: 2.1, reserveLaps: 1, finishBuffer: 1, maxStintLaps: 0 },
      lmu: { fuelUnit: 'L', tankCapacity: 90, pitLoss: 34, refuelRate: 2.2, reserveLaps: 1, finishBuffer: 1 },
      rfactor2: { fuelUnit: 'L', tankCapacity: 100, pitLoss: 32, refuelRate: 2.1, reserveLaps: 1, finishBuffer: 1 },
      custom: {}
    };

    var strategyMeta = {
      balanced: {
        label: 'Balanced fuel plan',
        shortLabel: 'Balanced',
        color: '#ff5a1f',
        multiplier: 1,
        note: 'Even stint lengths using your entered fuel burn and reserve.'
      },
      save: {
        label: 'Fuel save plan',
        shortLabel: 'Fuel Save',
        color: '#3fe08f',
        multiplier: null,
        note: 'Shows the result if the driver hits the fuel-save target every lap.'
      },
      push: {
        label: 'Push plan',
        shortLabel: 'Push',
        color: '#e31f26',
        multiplier: null,
        note: 'Shows the fuel risk if the car burns more while pushing.'
      },
      splash: {
        label: 'Short-fill plan',
        shortLabel: 'Short Fill',
        color: '#44c7ff',
        multiplier: 1,
        note: 'Adds one stop to reduce average fuel carried. Usually only wins when pit loss or refuel rules suit it.'
      }
    };

    function initCalculator(root) {
      if (!root || root.dataset.rscReady === 'true') {
        return;
      }

      root.dataset.rscReady = 'true';
      var state = {
        activeStrategy: 'balanced',
        selectedLap: 1,
        defaults: snapshotInputs(root)
      };

      root.querySelectorAll('[data-rsc-input]').forEach(function (input) {
        input.addEventListener('input', function () {
          if (input.dataset.rscInput === 'lapScrubber') {
            state.selectedLap = toNumber(input.value, 1);
          }
          update(root, state);
        });

        input.addEventListener('change', function () {
          if (input.dataset.rscInput === 'platform') {
            applyPlatformPreset(root, input.value);
          }
          update(root, state);
        });
      });

      root.querySelectorAll('[data-rsc-strategy]').forEach(function (button) {
        button.addEventListener('click', function () {
          state.activeStrategy = button.dataset.rscStrategy;
          update(root, state);
        });
      });

      var resetButton = root.querySelector('[data-rsc-reset]');
      if (resetButton) {
        resetButton.addEventListener('click', function () {
          restoreInputs(root, state.defaults);
          state.activeStrategy = 'balanced';
          state.selectedLap = 1;
          update(root, state);
        });
      }

      var chart = root.querySelector('[data-rsc-chart]');
      if (chart) {
        chart.addEventListener('click', function (event) {
          var rect = chart.getBoundingClientRect();
          var x = event.clientX - rect.left;
          var lap = chartLapFromX(x, rect.width, readInputs(root).raceLaps);
          state.selectedLap = lap;
          update(root, state);
        });
      }

      applyPlatformPreset(root, getInput(root, 'platform').value);
      update(root, state);
    }

    function snapshotInputs(root) {
      var values = {};
      root.querySelectorAll('[data-rsc-input]').forEach(function (input) {
        if (input.dataset.rscInput !== 'lapScrubber') {
          values[input.dataset.rscInput] = input.value;
        }
      });
      return values;
    }

    function restoreInputs(root, values) {
      Object.keys(values).forEach(function (key) {
        var input = getInput(root, key);
        if (input) {
          input.value = values[key];
        }
      });
    }

    function getInput(root, key) {
      return root.querySelector('[data-rsc-input="' + key + '"]');
    }

    function setOutput(root, key, value) {
      root.querySelectorAll('[data-rsc-output="' + key + '"]').forEach(function (node) {
        node.textContent = value;
      });
    }

    function applyPlatformPreset(root, platform) {
      var preset = platformPresets[platform] || {};
      ['fuelUnit', 'tankCapacity', 'pitLoss', 'refuelRate', 'reserveLaps', 'finishBuffer', 'maxStintLaps'].forEach(function (key) {
        if (preset[key] !== undefined) {
          var input = getInput(root, key);
          if (input) {
            input.value = preset[key];
          }
        }
      });
    }

    function readInputs(root) {
      var mode = getInput(root, 'raceMode').value;
      var lapSeconds = parseLapTime(getInput(root, 'lapTime').value);
      var durationSeconds = (toNumber(getInput(root, 'durationHours').value, 0) * 3600) + (toNumber(getInput(root, 'durationMinutes').value, 0) * 60);
      var finishBuffer = Math.max(0, Math.ceil(toNumber(getInput(root, 'finishBuffer').value, 0)));
      var raceLaps = mode === 'laps'
        ? Math.max(1, Math.ceil(toNumber(getInput(root, 'targetLaps').value, 1)))
        : Math.max(1, Math.ceil(durationSeconds / Math.max(lapSeconds, 1)) + finishBuffer);

      return {
        platform: getInput(root, 'platform').value,
        fuelUnit: getInput(root, 'fuelUnit').value || 'L',
        mode: mode,
        durationSeconds: durationSeconds,
        lapSeconds: lapSeconds,
        raceLaps: raceLaps,
        fuelPerLap: Math.max(0, toNumber(getInput(root, 'fuelPerLap').value, 0)),
        tankCapacity: Math.max(0, toNumber(getInput(root, 'tankCapacity').value, 0)),
        pitLoss: Math.max(0, toNumber(getInput(root, 'pitLoss').value, 0)),
        refuelRate: Math.max(0, toNumber(getInput(root, 'refuelRate').value, 0)),
        reserveLaps: Math.max(0, toNumber(getInput(root, 'reserveLaps').value, 0)),
        finishBuffer: finishBuffer,
        formationLaps: Math.max(0, toNumber(getInput(root, 'formationLaps').value, 0)),
        cooldownLaps: Math.max(0, toNumber(getInput(root, 'cooldownLaps').value, 0)),
        maxStintLaps: Math.max(0, Math.floor(toNumber(getInput(root, 'maxStintLaps').value, 0))),
        fuelSavePercent: Math.max(0, toNumber(getInput(root, 'fuelSavePercent').value, 0)),
        pushBurnPercent: Math.max(0, toNumber(getInput(root, 'pushBurnPercent').value, 0))
      };
    }

    function update(root, state) {
      var inputs = readInputs(root);
      toggleModeFields(root, inputs.mode);
      updateUnitLabels(root, inputs.fuelUnit);

      var plans = buildPlans(inputs);
      var activePlan = plans[state.activeStrategy] || plans.balanced;

      if (state.selectedLap > inputs.raceLaps || state.selectedLap < 1) {
        state.selectedLap = Math.min(Math.max(1, state.selectedLap), inputs.raceLaps);
      }

      var scrubber = getInput(root, 'lapScrubber');
      if (scrubber) {
        scrubber.max = String(inputs.raceLaps);
        scrubber.value = String(state.selectedLap);
      }

      renderSummary(root, inputs, activePlan);
      renderStrategyCards(root, plans, state.activeStrategy, inputs.fuelUnit);
      renderChart(root, inputs, activePlan, state.selectedLap);
      renderLapInspector(root, inputs, activePlan, state.selectedLap);
      renderStintTable(root, activePlan, inputs.fuelUnit);
      renderWarnings(root, inputs, activePlan);
    }

    function toggleModeFields(root, mode) {
      root.querySelectorAll('[data-rsc-time-input]').forEach(function (node) {
        node.hidden = mode !== 'time';
      });

      root.querySelectorAll('[data-rsc-lap-input]').forEach(function (node) {
        node.hidden = mode !== 'laps';
      });
    }

    function updateUnitLabels(root, unit) {
      root.querySelectorAll('[data-rsc-unit-label]').forEach(function (node) {
        node.textContent = unit;
      });
    }

    function buildPlans(inputs) {
      strategyMeta.save.multiplier = 1 - (inputs.fuelSavePercent / 100);
      strategyMeta.push.multiplier = 1 + (inputs.pushBurnPercent / 100);

      return {
        balanced: buildPlan(inputs, 'balanced'),
        save: buildPlan(inputs, 'save'),
        push: buildPlan(inputs, 'push'),
        splash: buildPlan(inputs, 'splash')
      };
    }

    function buildPlan(inputs, strategyKey) {
      var meta = strategyMeta[strategyKey];
      var multiplier = Math.max(0.1, meta.multiplier || 1);
      var fuelPerLap = inputs.fuelPerLap * multiplier;
      var reserveFuel = inputs.reserveLaps * fuelPerLap;
      var formationFuel = inputs.formationLaps * fuelPerLap;
      var cooldownFuel = inputs.cooldownLaps * fuelPerLap;
      var warnings = [];

      if (!inputs.lapSeconds || inputs.lapSeconds <= 0) {
        warnings.push({ level: 'critical', text: 'Average lap time must be higher than zero.' });
      }

      if (!fuelPerLap || fuelPerLap <= 0) {
        warnings.push({ level: 'critical', text: 'Fuel per lap must be higher than zero.' });
      }

      if (!inputs.tankCapacity || inputs.tankCapacity <= 0) {
        warnings.push({ level: 'critical', text: 'Tank capacity must be higher than zero.' });
      }

      var minimumSingleLapLoad = fuelPerLap + reserveFuel;
      if (inputs.tankCapacity > 0 && fuelPerLap > 0 && minimumSingleLapLoad > inputs.tankCapacity + 0.0001) {
        warnings.push({ level: 'critical', text: 'One racing lap plus reserve is larger than the tank. Reduce reserve or check the fuel numbers.' });
      }

      var capacityStints = inputs.tankCapacity > 0
        ? Math.ceil(((inputs.raceLaps * fuelPerLap) + reserveFuel + formationFuel + cooldownFuel) / inputs.tankCapacity)
        : 1;
      var stintLimitStints = inputs.maxStintLaps > 0 ? Math.ceil(inputs.raceLaps / inputs.maxStintLaps) : 1;
      var stintsNeeded = Math.max(1, capacityStints, stintLimitStints);

      if (strategyKey === 'splash' && inputs.raceLaps > 3) {
        stintsNeeded += 1;
      }

      stintsNeeded = Math.min(Math.max(1, stintsNeeded), Math.max(1, inputs.raceLaps));

      var stints = [];
      var valid = false;
      var guard = 0;

      while (!valid && guard < inputs.raceLaps + 6) {
        var lapBlocks = distributeLaps(inputs.raceLaps, stintsNeeded, strategyKey);
        stints = createStints(lapBlocks, fuelPerLap, reserveFuel, formationFuel, cooldownFuel, inputs);
        valid = stints.every(function (stint) {
          return stint.startFuel <= inputs.tankCapacity + 0.0001 && (!inputs.maxStintLaps || stint.laps <= inputs.maxStintLaps);
        });

        if (!valid) {
          stintsNeeded += 1;
          stintsNeeded = Math.min(stintsNeeded, Math.max(1, inputs.raceLaps));
        }

        guard += 1;
      }

      if (!valid) {
        warnings.push({ level: 'critical', text: 'This fuel load cannot be planned inside the entered tank or stint limit.' });
      }

      var fuelAddedAtStops = stints.reduce(function (total, stint) {
        return total + stint.fuelAdded;
      }, 0);
      var fuelServiceTime = inputs.refuelRate > 0 ? fuelAddedAtStops / inputs.refuelRate : 0;
      var pitStops = Math.max(0, stints.length - 1);
      var paceTime = inputs.raceLaps * inputs.lapSeconds;
      var totalTime = paceTime + (pitStops * inputs.pitLoss) + fuelServiceTime;
      var totalFuelRequired = (inputs.raceLaps * fuelPerLap) + formationFuel + cooldownFuel + reserveFuel;
      var finalStock = stints.length ? Math.max(0, stints[stints.length - 1].endFuel - cooldownFuel) : 0;
      var averageStint = stints.length ? inputs.raceLaps / stints.length : 0;

      if (inputs.mode === 'time' && inputs.finishBuffer < 1) {
        warnings.push({ level: 'warning', text: 'Timed race has no finish buffer. Add one lap unless your league rules say otherwise.' });
      }

      if (inputs.refuelRate <= 0 && pitStops > 0) {
        warnings.push({ level: 'warning', text: 'Refuel rate is zero, so estimated clock only includes pit lane loss, not fuel service time.' });
      }

      return {
        key: strategyKey,
        meta: meta,
        fuelPerLap: fuelPerLap,
        reserveFuel: reserveFuel,
        formationFuel: formationFuel,
        cooldownFuel: cooldownFuel,
        stints: stints,
        pitStops: pitStops,
        startFuel: stints.length ? stints[0].startFuel : 0,
        totalFuelRequired: totalFuelRequired,
        totalTime: totalTime,
        fuelServiceTime: fuelServiceTime,
        finalStock: finalStock,
        averageStint: averageStint,
        warnings: warnings
      };
    }

    function distributeLaps(totalLaps, stintCount, strategyKey) {
      var laps = [];
      var count = Math.max(1, Math.min(stintCount, totalLaps));
      var remaining = totalLaps;

      for (var index = 0; index < count; index += 1) {
        var slotsLeft = count - index;
        var stintLaps;

        if (strategyKey === 'splash' && index === count - 1 && remaining > slotsLeft) {
          stintLaps = Math.max(1, Math.floor(totalLaps / count) - 1);
        } else {
          stintLaps = Math.ceil(remaining / slotsLeft);
        }

        stintLaps = Math.max(1, Math.min(stintLaps, remaining - (slotsLeft - 1)));
        laps.push(stintLaps);
        remaining -= stintLaps;
      }

      return laps;
    }

    function createStints(lapBlocks, fuelPerLap, reserveFuel, formationFuel, cooldownFuel, inputs) {
      var stints = [];
      var startLap = 1;

      lapBlocks.forEach(function (lapCount, index) {
        var isFirst = index === 0;
        var isLast = index === lapBlocks.length - 1;
        var extraBefore = isFirst ? formationFuel : 0;
        var extraAfter = isLast ? cooldownFuel : 0;
        var startFuel = (lapCount * fuelPerLap) + reserveFuel + extraBefore + extraAfter;
        var endFuel = Math.max(0, startFuel - (lapCount * fuelPerLap));
        var endLap = startLap + lapCount - 1;

        stints.push({
          number: index + 1,
          startLap: startLap,
          endLap: endLap,
          laps: lapCount,
          startFuel: startFuel,
          endFuel: endFuel,
          fuelAdded: 0,
          windowStart: Math.max(startLap, endLap - 2),
          windowEnd: endLap
        });

        startLap = endLap + 1;
      });

      for (var i = 0; i < stints.length - 1; i += 1) {
        stints[i].fuelAdded = Math.max(0, stints[i + 1].startFuel - stints[i].endFuel);
      }

      return stints;
    }

    function renderSummary(root, inputs, plan) {
      setOutput(root, 'raceLaps', String(inputs.raceLaps));
      setOutput(root, 'pitStops', String(plan.pitStops));
      setOutput(root, 'startFuel', formatFuel(plan.startFuel, inputs.fuelUnit));
      setOutput(root, 'totalFuel', formatFuel(plan.totalFuelRequired, inputs.fuelUnit));
      setOutput(root, 'totalTime', formatClock(plan.totalTime));
      setOutput(root, 'finishFuel', formatFuel(plan.finalStock, inputs.fuelUnit));
      setOutput(root, 'finishNote', 'After cool down, expected reserve is ' + formatFuel(plan.finalStock, inputs.fuelUnit) + '.');
      setOutput(root, 'selectedStrategy', plan.meta.label);
      setOutput(root, 'strategyNote', plan.meta.note + ' Average stint is ' + formatNumber(plan.averageStint, 1) + ' laps.');

      var statusTitle = root.querySelector('[data-rsc-status-title]');
      var statusCopy = root.querySelector('[data-rsc-status-copy]');
      var statusLight = root.querySelector('[data-rsc-status-light]');
      var critical = plan.warnings.some(function (warning) { return warning.level === 'critical'; });
      var warning = plan.warnings.length > 0;

      if (statusLight) {
        statusLight.classList.toggle('is-critical', critical);
        statusLight.classList.toggle('is-warning', warning && !critical);
      }

      if (statusTitle && statusCopy) {
        if (critical) {
          statusTitle.textContent = 'Check inputs';
          statusCopy.textContent = 'The calculator found a fuel or tank conflict.';
        } else if (warning) {
          statusTitle.textContent = 'Review margin';
          statusCopy.textContent = 'Plan is built, but one assumption needs checking.';
        } else {
          statusTitle.textContent = 'Strategy ready';
          statusCopy.textContent = plan.pitStops + ' stop plan with ' + formatFuel(plan.startFuel, inputs.fuelUnit) + ' start fuel.';
        }
      }
    }

    function renderStrategyCards(root, plans, activeStrategy, unit) {
      Object.keys(plans).forEach(function (key) {
        var plan = plans[key];
        var title = root.querySelector('[data-rsc-card="' + key + '-title"]');
        var copy = root.querySelector('[data-rsc-card="' + key + '-copy"]');
        var button = root.querySelector('[data-rsc-strategy="' + key + '"]');

        if (title) {
          title.textContent = plan.pitStops + ' stops | ' + formatFuel(plan.startFuel, unit);
        }

        if (copy) {
          copy.textContent = formatNumber(plan.fuelPerLap, 2) + ' ' + unit + '/lap, avg ' + formatNumber(plan.averageStint, 1) + ' laps per stint.';
        }

        if (button) {
          button.classList.toggle('is-active', key === activeStrategy);
        }
      });
    }

    function renderChart(root, inputs, plan, selectedLap) {
      var svg = root.querySelector('[data-rsc-chart]');
      if (!svg) {
        return;
      }

      while (svg.firstChild) {
        svg.removeChild(svg.firstChild);
      }

      var width = 960;
      var height = 360;
      var pad = { top: 24, right: 32, bottom: 42, left: 54 };
      var plotW = width - pad.left - pad.right;
      var plotH = height - pad.top - pad.bottom;
      var maxFuel = Math.max(inputs.tankCapacity, plan.startFuel, 1);

      drawChartGrid(svg, width, height, pad, plotW, plotH, inputs, maxFuel);

      var reserveY = yForFuel(plan.reserveFuel, maxFuel, pad, plotH);
      appendLine(svg, pad.left, reserveY, pad.left + plotW, reserveY, '#ffd34d', 2, '5 6');
      appendText(svg, pad.left + 8, Math.max(16, reserveY - 7), 'Reserve', '#ffd34d', 11, 'start');

      plan.stints.forEach(function (stint, index) {
        var x0 = xForLap(stint.startLap - 1, inputs.raceLaps, pad, plotW);
        var x1 = xForLap(stint.endLap, inputs.raceLaps, pad, plotW);
        var y0 = yForFuel(stint.startFuel, maxFuel, pad, plotH);
        var y1 = yForFuel(stint.endFuel, maxFuel, pad, plotH);
        var yBottom = pad.top + plotH;
        var opacity = 0.2 + (index % 2) * 0.05;

        appendPolygon(svg, [
          [x0, y0],
          [x1, y1],
          [x1, yBottom],
          [x0, yBottom]
        ], plan.meta.color, opacity);

        appendLine(svg, x0, y0, x1, y1, plan.meta.color, 3, null);
        appendCircle(svg, x0, y0, 4, plan.meta.color);
        appendCircle(svg, x1, y1, 4, plan.meta.color);

        if (index < plan.stints.length - 1) {
          appendLine(svg, x1, pad.top, x1, yBottom, '#44c7ff', 2, '4 5');
          appendText(svg, x1 + 5, pad.top + 18, 'Pit ' + stint.endLap, '#8bdfff', 11, 'start');
        }

        appendText(svg, x0 + 10, yBottom - 12, 'S' + stint.number, 'rgba(246,248,251,0.72)', 11, 'start');
      });

      var selectedX = xForLap(selectedLap, inputs.raceLaps, pad, plotW);
      appendLine(svg, selectedX, pad.top, selectedX, pad.top + plotH, '#ffffff', 1.5, '3 5');

      var lapState = getFuelAtLap(plan, selectedLap);
      if (lapState) {
        appendCircle(svg, selectedX, yForFuel(lapState.fuel, maxFuel, pad, plotH), 5, '#ffffff');
        positionTooltip(root, selectedX / width, lapState, selectedLap, inputs.fuelUnit);
      }
    }

    function drawChartGrid(svg, width, height, pad, plotW, plotH, inputs, maxFuel) {
      var ySteps = 4;
      var xSteps = Math.min(8, Math.max(2, inputs.raceLaps));

      appendLine(svg, pad.left, pad.top, pad.left, pad.top + plotH, 'rgba(255,255,255,0.22)', 1, null);
      appendLine(svg, pad.left, pad.top + plotH, pad.left + plotW, pad.top + plotH, 'rgba(255,255,255,0.22)', 1, null);

      for (var y = 0; y <= ySteps; y += 1) {
        var ratioY = y / ySteps;
        var lineY = pad.top + (plotH * ratioY);
        var fuel = maxFuel * (1 - ratioY);
        appendLine(svg, pad.left, lineY, pad.left + plotW, lineY, 'rgba(255,255,255,0.08)', 1, null);
        appendText(svg, pad.left - 8, lineY + 4, formatNumber(fuel, 0), 'rgba(246,248,251,0.62)', 11, 'end');
      }

      for (var x = 0; x <= xSteps; x += 1) {
        var lap = Math.round((inputs.raceLaps / xSteps) * x);
        var lineX = xForLap(lap, inputs.raceLaps, pad, plotW);
        appendLine(svg, lineX, pad.top, lineX, pad.top + plotH, 'rgba(255,255,255,0.06)', 1, null);
        appendText(svg, lineX, height - 15, String(lap), 'rgba(246,248,251,0.62)', 11, 'middle');
      }

      appendText(svg, pad.left, height - 6, 'Race lap', 'rgba(246,248,251,0.72)', 11, 'start');
      appendText(svg, 10, pad.top + 12, 'Fuel', 'rgba(246,248,251,0.72)', 11, 'start');
    }

    function renderLapInspector(root, inputs, plan, selectedLap) {
      var lapState = getFuelAtLap(plan, selectedLap);
      setOutput(root, 'selectedLap', String(selectedLap));

      if (!lapState) {
        setOutput(root, 'lapFuel', '--');
        setOutput(root, 'lapNote', 'No fuel state available for this lap.');
        setOutput(root, 'pitWindow', '--');
        setOutput(root, 'pitWindowNote', 'No planned pit window.');
        return;
      }

      setOutput(root, 'lapFuel', formatFuel(lapState.fuel, inputs.fuelUnit));
      setOutput(root, 'lapNote', lapState.note);

      var nextPit = plan.stints.find(function (stint) {
        return stint.endLap >= selectedLap && stint.number < plan.stints.length;
      });

      if (nextPit) {
        setOutput(root, 'pitWindow', 'Lap ' + nextPit.windowStart + '-' + nextPit.windowEnd);
        setOutput(root, 'pitWindowNote', 'Planned stop after lap ' + nextPit.endLap + ' with about ' + formatFuel(nextPit.endFuel, inputs.fuelUnit) + ' in stock.');
      } else {
        setOutput(root, 'pitWindow', 'Finish');
        setOutput(root, 'pitWindowNote', 'No more pit stops planned from this lap.');
      }
    }

    function renderStintTable(root, plan, unit) {
      var tbody = root.querySelector('[data-rsc-stint-table]');
      if (!tbody) {
        return;
      }

      while (tbody.firstChild) {
        tbody.removeChild(tbody.firstChild);
      }

      plan.stints.forEach(function (stint, index) {
        var row = document.createElement('tr');
        var addFuel = index < plan.stints.length - 1 ? formatFuel(stint.fuelAdded, unit) : 'Finish';
        var pitStock = index < plan.stints.length - 1 ? formatFuel(stint.endFuel, unit) : formatFuel(stint.endFuel, unit);
        var windowText = index < plan.stints.length - 1 ? 'Lap ' + stint.windowStart + '-' + stint.windowEnd : 'Checkered';

        row.innerHTML =
          '<td><strong>' + stint.number + '</strong></td>' +
          '<td>Lap ' + stint.startLap + '-' + stint.endLap + '<br>' + stint.laps + ' laps</td>' +
          '<td><strong>' + formatFuel(stint.startFuel, unit) + '</strong></td>' +
          '<td>' + pitStock + '</td>' +
          '<td>' + addFuel + '</td>' +
          '<td>' + windowText + '</td>';
        tbody.appendChild(row);
      });
    }

    function renderWarnings(root, inputs, plan) {
      var warnings = root.querySelector('[data-rsc-warnings]');
      if (!warnings) {
        return;
      }

      while (warnings.firstChild) {
        warnings.removeChild(warnings.firstChild);
      }

      var messages = plan.warnings.slice();
      if (inputs.platform !== 'custom') {
        messages.push({
          level: 'warning',
          text: 'Platform preset is a starting point only. Car, BoP, weather, track grip, damage, and server pit rules still need your real telemetry.'
        });
      }

      messages.forEach(function (message) {
        var node = document.createElement('div');
        node.className = 'race-strategy-calculator__warning' + (message.level === 'critical' ? ' is-critical' : '');
        node.textContent = message.text;
        warnings.appendChild(node);
      });
    }

    function getFuelAtLap(plan, lap) {
      var stint = plan.stints.find(function (item) {
        return lap >= item.startLap && lap <= item.endLap;
      });

      if (!stint) {
        return null;
      }

      var lapsCompletedInStint = Math.max(0, lap - stint.startLap + 1);
      var fuel = Math.max(0, stint.startFuel - (lapsCompletedInStint * plan.fuelPerLap));
      var note = 'After lap ' + lap + ', stint ' + stint.number + ' has ' + Math.max(0, stint.endLap - lap) + ' racing laps left.';

      if (lap === stint.endLap && stint.number < plan.stints.length) {
        note = 'Pit after this lap. Arrive with planned reserve stock.';
      } else if (stint.number === plan.stints.length && lap === stint.endLap) {
        note = 'Checkered flag. Cool down fuel and reserve remain in the plan.';
      }

      return { stint: stint, fuel: fuel, note: note };
    }

    function chartLapFromX(x, width, raceLaps) {
      var padLeftRatio = 54 / 960;
      var padRightRatio = 32 / 960;
      var plotLeft = width * padLeftRatio;
      var plotW = width * (1 - padLeftRatio - padRightRatio);
      var ratio = (x - plotLeft) / Math.max(1, plotW);
      return Math.min(Math.max(1, Math.round(ratio * raceLaps)), raceLaps);
    }

    function positionTooltip(root, xRatio, lapState, selectedLap, unit) {
      var tip = root.querySelector('[data-rsc-tooltip]');
      var lap = root.querySelector('[data-rsc-tip-lap]');
      var fuel = root.querySelector('[data-rsc-tip-fuel]');
      var note = root.querySelector('[data-rsc-tip-note]');

      if (!tip || !lap || !fuel || !note) {
        return;
      }

      tip.hidden = false;
      tip.style.left = (xRatio > 0.72 ? 'auto' : (Math.max(0.03, xRatio) * 100) + '%');
      tip.style.right = (xRatio > 0.72 ? '16px' : 'auto');
      lap.textContent = 'Lap ' + selectedLap;
      fuel.textContent = formatFuel(lapState.fuel, unit);
      note.textContent = lapState.note;
    }

    function xForLap(lap, raceLaps, pad, plotW) {
      return pad.left + ((Math.max(0, lap) / Math.max(1, raceLaps)) * plotW);
    }

    function yForFuel(fuel, maxFuel, pad, plotH) {
      return pad.top + ((1 - (Math.max(0, fuel) / Math.max(1, maxFuel))) * plotH);
    }

    function appendLine(svg, x1, y1, x2, y2, stroke, width, dash) {
      var node = document.createElementNS(SVG_NS, 'line');
      node.setAttribute('x1', x1);
      node.setAttribute('y1', y1);
      node.setAttribute('x2', x2);
      node.setAttribute('y2', y2);
      node.setAttribute('stroke', stroke);
      node.setAttribute('stroke-width', width);
      node.setAttribute('stroke-linecap', 'round');
      if (dash) {
        node.setAttribute('stroke-dasharray', dash);
      }
      svg.appendChild(node);
    }

    function appendPolygon(svg, points, color, opacity) {
      var node = document.createElementNS(SVG_NS, 'polygon');
      node.setAttribute('points', points.map(function (point) { return point[0] + ',' + point[1]; }).join(' '));
      node.setAttribute('fill', color);
      node.setAttribute('opacity', opacity);
      svg.appendChild(node);
    }

    function appendCircle(svg, x, y, radius, color) {
      var node = document.createElementNS(SVG_NS, 'circle');
      node.setAttribute('cx', x);
      node.setAttribute('cy', y);
      node.setAttribute('r', radius);
      node.setAttribute('fill', color);
      svg.appendChild(node);
    }

    function appendText(svg, x, y, text, fill, size, anchor) {
      var node = document.createElementNS(SVG_NS, 'text');
      node.setAttribute('x', x);
      node.setAttribute('y', y);
      node.setAttribute('fill', fill);
      node.setAttribute('font-size', size);
      node.setAttribute('font-weight', '800');
      node.setAttribute('text-anchor', anchor || 'start');
      node.textContent = text;
      svg.appendChild(node);
    }

    function parseLapTime(value) {
      var text = String(value || '').trim().replace(',', '.');
      if (!text) {
        return 0;
      }

      if (text.indexOf(':') === -1) {
        return toNumber(text, 0);
      }

      var parts = text.split(':').map(function (part) {
        return toNumber(part, 0);
      });

      if (parts.length === 2) {
        return (parts[0] * 60) + parts[1];
      }

      if (parts.length === 3) {
        return (parts[0] * 3600) + (parts[1] * 60) + parts[2];
      }

      return 0;
    }

    function toNumber(value, fallback) {
      var number = parseFloat(String(value || '').replace(',', '.'));
      return Number.isFinite(number) ? number : fallback;
    }

    function formatNumber(value, decimals) {
      return Number(value || 0).toLocaleString(undefined, {
        maximumFractionDigits: decimals,
        minimumFractionDigits: decimals
      });
    }

    function formatFuel(value, unit) {
      return formatNumber(value, value >= 100 ? 0 : 1) + unit;
    }

    function formatClock(seconds) {
      seconds = Math.max(0, Math.round(seconds || 0));
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor((seconds % 3600) / 60);
      var secs = seconds % 60;

      if (hours > 0) {
        return hours + ':' + pad(minutes) + ':' + pad(secs);
      }

      return minutes + ':' + pad(secs);
    }

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function boot() {
      document.querySelectorAll('[data-rsc]').forEach(initCalculator);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target) {
        event.target.querySelectorAll('[data-rsc]').forEach(initCalculator);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
